import { Button } from "@/components/ui/button";

export const GoldButton = ({ className = "", children, ...props }) => (
    <Button
        className={`rounded-lg h-12 px-8 bg-[#C8A45D] text-[#111318] text-[13px] font-bold tracking-[0.1em] uppercase hover:bg-[#D3B677] hover:shadow-[0_10px_28px_rgba(200,164,93,0.35)] transition-all duration-300 ${className}`}
        {...props}
    >
        {children}
    </Button>
);

export const GhostButton = ({ className = "", children, ...props }) => (
    <Button
        variant="outline"
        className={`rounded-lg h-12 px-8 border-white/25 bg-transparent text-white text-[13px] font-semibold tracking-[0.1em] uppercase hover:border-[#C8A45D] hover:text-[#C8A45D] transition-all duration-300 ${className}`}
        {...props}
    >
        {children}
    </Button>
);
